// =====================================
//
//   補收款 atm付款 Controller
//   Author: Gray
//   createtime: 2017 / 03 / 16
//
// =====================================

window.InifECMobileApp.controller("ExtrafeePaymentSinopacATMController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'UserService', 'ExtraFeeService',
	function($scope, $state, $timeout, $rootScope, $stateParams, UserService, ExtraFeeService) {

        var getExtraFee = function() {

            $scope.isLoading = true;
            ExtraFeeService.getExtraFee($scope.extrafeeid).then(function(result) {

                if(result) {
                    $scope.extrafee = result;
                    $scope.orderid = $scope.extrafee.orderid;
                    
                    if($scope.extrafee.status != 300) {
                        $scope.isLoading = false;
                        $scope.isStatusError = true;
                    } else {
                        pay();    
                    }

                } else {
                    $scope.isError = true;
                    $scope.isLoading = false;
                }

            }, function(error) {
                if(error && error.code == 'error.itemIsNotExist') {
                    $scope.isExtrafeeNotExist = true;
                } else {
                    $scope.isError = true;
                }
                
                $scope.isLoading = false;
            });
        }

        var pay = function() {

            if(!$scope.extrafee) {
                $scope.isError = true;
                return;
            }

            var extrafeeid = $scope.extrafeeid,
                paymentmethod = Paytype_SinopacATM,
                totalamount = $scope.extrafee.totalamount;

            ExtraFeeService.payExtraFee(extrafeeid, paymentmethod, totalamount).then(function(result) {
                if(result) {
                    // 處理ATM資料
                    try {
                        $scope.atminfo = angular.fromJson(result.gatewayRstJSON);
                    } catch (e) {
                        console.log(e);
                    }

                    $scope.isLoading = false;
                    $scope.isError = false;
                    $scope.isComplete = true;
                } else {
                    $scope.isError = true;
                    $scope.isLoading = false;
                }             
            }, function(error) {
                $scope.isError = true;
                $scope.isLoading = false;
            });
        }

        var init = function() {
            
            UserService.getUserInfo().then(function(result) {
                $scope.isLogin = true;
                getExtraFee();
            }, function(error) {
                $scope.isLogin = false;

                $state.go(window.STATES.HOME);
            });
        }

	    //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.extrafeeid = $stateParams.extrafeeid;
        $scope.orderid = $stateParams.orderid;
        $scope.extrafee;
        $scope.atminfo;
        $scope.isError = false;
        $scope.isLoading = false;
        $scope.isComplete = false;
        $scope.isExtrafeeNotExist = false;
        $scope.isOverError = false;

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        init();
	}
]);